export const routes = [
  {
    path: '/subject-areas',
    name: 'subject-areas',
    iconName: 'file-alt',
    title: 'Subject Areas',
    children: [
      {
        path: '/subject-areas/listing',
        title: 'All Subject Areas',
        name: 'subject-areas.listing.all',
      },
      {
        path: '/subject-areas/reports',
        title: 'Reports',
        name: 'subject-areas.reports.all',
      },
      {
        path: '/subject-areas/listing/:listingId',
        hideFromNav: true,
        name: 'subject-areas.listing.single',
        meta: {
          backToData: {
            pathName: 'subject-areas.listing.all',
            title: 'Subject Areas Listing',
          },
          customTitle: 'Subject Area',
          customNavChildItems: [
            {
              title: 'Content',
              name: 'subject-areas.listing.single',
            },
            {
              title: 'Categories',
              name: 'subject-areas.listing.single.categories',
            },
            {
              title: 'Resource Types',
              name: 'subject-areas.listing.single.resource-types',
            },
          ],
        },
        children: [
          {
            path: 'categories',
            name: 'subject-areas.listing.single.categories',
            meta: {
              customTitle: 'Subject Area',
              customNavChildItems: [
                {
                  title: 'Content',
                  name: 'subject-areas.listing.single',
                },
                {
                  title: 'Categories',
                  name: 'subject-areas.listing.single.categories',
                },
                {
                  title: 'Resource Types',
                  name: 'subject-areas.listing.single.resource-types',
                },
              ],
              backToData: {
                pathName: 'subject-areas.listing.all',
                title: 'Subject Areas Listing',
              },
            },
          },
          {
            path: 'resource-types',
            name: 'subject-areas.listing.single.resource-types',
            meta: {
              customTitle: 'Subject Area',
              customNavChildItems: [
                {
                  title: 'Content',
                  name: 'subject-areas.listing.single',
                },
                {
                  title: 'Categories',
                  name: 'subject-areas.listing.single.categories',
                },
                {
                  title: 'Resource Types',
                  name: 'subject-areas.listing.single.resource-types',
                },
              ],
              backToData: {
                pathName: 'subject-areas.listing.all',
                title: 'Subject Areas Listing',
              },
            },
          },
        ],
      },
      {
        path: '/subject-areas/listing/:listingId/edit/:contentId',
        hideFromNav: true,
        name: 'subject-areas.listing.edit',
        meta: {
          hideNav: true,
        },
      },
      {
        path: '/subject-areas/listing/edit/:contentId/quiz-report',
        hideFromNav: true,
        name: 'subject-areas.listing.single.quiz-report',
        meta: {
          hideNav: true,
        },
      },
    ],
  },
  {
    path: '/users',
    name: 'users',
    iconName: 'user-shield',
    title: 'Users',
    roles: ['Super Admin'],
    children: [
      {
        path: '/users/super-admins',
        title: 'Super Admins',
        name: 'users.super-admins',
      },
      {
        path: '/users/area-admins',
        title: 'Area Admins',
        name: 'users.area-admins',
      },
      {
        path: '/users/registrants',
        title: 'Registrants',
        name: 'users.registrants',
      },
    ],
  },
  {
    path: '/announcements',
    name: 'announcements',
    iconName: 'bullhorn',
    title: 'Announcements',
    roles: ['Super Admin'],
    children: [
      {
        path: '/announcements',
        title: 'Announcements',
        name: 'announcements.index',
      },
    ],
  },
  {
    path: '/splash-page',
    name: 'splash-page',
    iconName: 'home',
    title: 'Splash Page',
    roles: ['Super Admin'],
    children: [
      {
        path: '/splash-page',
        title: 'Splash Page',
        name: 'splash-page.index',
      },
    ],
  },
  {
    path: '/profile',
    hideFromNav: true,
    meta: {
      hideNav: true,
    },
  },
  {
    path: '/org-settings',
    name: 'org-settings',
    hideFromNav: true,
    roles: ['Super Admin'],
  },
  {
    path: '/manageaccount/changepassword',
    hideFromNav: true,
    meta: {
      hideNav: true,
    },
  },
];